export default {
  CLIENT_ID: '5c5c53681310ce5e78967be6ad9de8',
  REDIRECT: 'http://localhost:8083',
  APP_URL: 'http://localhost:8082',
  API_URL: 'http://localhost:3007',
}
